import { RiErrorWarningFill } from "react-icons/ri";
import { Modal } from "antd";
import { FooterButtons } from "./ModalHelper";

const CancelModal = ({ visible, toggleCancelModal, closeModal }) => {
	return (
		<Modal
			closable={false}
			visible={visible}
			footer={null}
			centered
			width={375}
			bodyStyle={{
				padding: "2rem",
				flexDirection: "column",
				display: "flex",

				justifyContent: "space-between",
			}}
		>
			<div
				style={{
					marginBottom: 20,
					justifyContent: "center",
					display: "flex",
					flexDirection: "column",
				}}
			>
				<div
					style={{
						marginBottom: 20,
						display: "flex",
						justifyContent: "center",
					}}
				>
					<div
						style={{
							marginRight: "0.5rem",
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
						}}
					>
						<RiErrorWarningFill color="#F57171" size={20} />
					</div>
					<div style={{ fontSize: 18, fontWeight: 800, textAlign: "center" }}>
						Changes will not be saved
					</div>
				</div>

				<div
					style={{ display: "flex", justifyContent: "center", fontSize: 14 }}
				>
					<div style={{ color: "#4F5655", textAlign: "center" }}>
						Do you wish to save the changes made to this user profile?
					</div>
				</div>
			</div>
			<FooterButtons
				handleCancel={() => {
					toggleCancelModal(false);
					closeModal(false);
				}}
				handleAction={() => toggleCancelModal(false)}
				actionButtonLabel={"Continue Editing"}
				cancelButtonLabel={"Discard"}
				styles={{ width: 140 }}
			/>
		</Modal>
	);
};

export default CancelModal;
